import { redirect } from 'react-router-dom';
import { store } from '@/store/store';
import { whitelabelConfig } from '@/config/whitelabel';

const configuredStoreDashboardPath = `/${whitelabelConfig.storeType}/${whitelabelConfig.storeId}/dashboard`;

export async function rootLoader() {
  console.log('[rootLoader] Executing root loader...');

  const state = store.getState();
  const { isAuthenticated, verifiedStores, currentStoreInfo } = state.auth;

  console.log('[rootLoader] Auth state:', {
    isAuthenticated,
    verifiedStoresCount: verifiedStores.length,
  });

  if (!isAuthenticated) {
    console.log('[rootLoader] Not authenticated, redirecting to /auth/login');
    return redirect('/auth/login');
  }

  if (currentStoreInfo?.storeId === whitelabelConfig.storeId) {
    console.log('[rootLoader] Configured store selected, redirecting to dashboard');
    return redirect(configuredStoreDashboardPath);
  }

  const configuredStore = verifiedStores.find(
    (candidate) =>
      candidate.storeId === whitelabelConfig.storeId &&
      candidate.storeType === whitelabelConfig.storeType,
  );

  if (configuredStore) {
    console.log('[rootLoader] Configured store available, redirecting to dashboard');
    return redirect(configuredStoreDashboardPath);
  }

  console.log('[rootLoader] Configured store unavailable, redirecting to login');
  return redirect('/auth/login');
}
